import { Outlet } from "react-router-dom";

const PMFBYOutlet = () => <Outlet />;

export default PMFBYOutlet;
